export { registerInquiry } from './api/register-inquiry/request'
export type { TRegisterInquiry } from './api/register-inquiry/schema'
export { getFAQCategories } from './api/get-faq-categories'
export { getFAQs, type TFAQSearchParams } from './api/get-faqs'
export { getTopFAQs } from './api/get-top-faqs'
export { getInquiries } from './api/get-inquiries'
export { getNotice } from './api/get-notice'
export {
  InquiryStatus,
  type TInquiry,
  type TFAQ,
  type TTopFAQ,
  type TFAQCategory,
  type TFAQCategories,
  type TNoticeSummary,
  type TNotice,
} from './model/schema'

export { supportQueries } from './api/query'
